import { MembershipProfile } from '@models/membership/MembershipProfile'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  selectMembershipProfileById,
  updateMembershipProfileTags,
} from '@store/membership/MembershipProfileReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Entity } from '@utils/Entities'
import { App, Form, Space } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_SUCCESS } from '../../../App'
import MembershipProfileTag from '../membership-profile-tag/MembershipProfileTag'

type Props = SBModelComponent<MembershipProfile> & {
  onChange?: () => void
}

const TagManager: FC<Props> = ({ id, model, onChange }: Props) => {
  const { message } = App.useApp()

  const dispatch = useAppDispatch()
  const item = model ? model : useAppSelector(selectMembershipProfileById(id!))

  const [isLoading, setIsLoading] = useState<boolean>(false)

  if (!item) {
    return <></>
  }

  const handleTagChange = (values: number[]) => {
    setIsLoading(true)
    dispatch(updateMembershipProfileTags({ ...item, tags: values }))
      .then(() => {
        message.success(DEFAULT_SUCCESS)
        onChange?.()
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Form
      className="w-full"
      layout="horizontal"
      initialValues={{ tags: item.tags }}
    >
      <Space.Compact className="w-full">
        <Form.Item name={'tags'} noStyle className="w-full">
          <SBAsyncSelect
            style={{ width: '100%' }}
            multiple
            entity={Entity.membershipProfileTag}
            allowClear
            disabled={isLoading}
            inlineEdit={{
              renderSelection: () => (
                <Space wrap>
                  {(item.tags ?? []).map((tag) => (
                    <MembershipProfileTag.Tag key={tag} id={tag} />
                  ))}
                </Space>
              ),
            }}
            onChange={handleTagChange}
          />
        </Form.Item>
      </Space.Compact>
    </Form>
  )
}

type TagManagerType = {
  TagManager: typeof TagManager
}
export { TagManager, type TagManagerType }
